import React from "react";
import "./OtherAffiliatePartner.css";
import { Apiurl, Encryption } from "../../Pages/utils/page";
import moment from "moment";
import ProductCountdown from "../Countdown/Countdown";
import { useNavigate } from "react-router-dom";

const OtherAffiliatePartner = ({
  allProductsData,
  totalRecordAffiliate,
  getAllProducts,
  pageNumberAffiliate,
}) => {
  const router = useNavigate();

  return (
    <>
      <div className="vendor-main-product">
        <div className="container">
          {allProductsData?.length ? (
            <div className="section_space">
              <div className="row">
                <div className="col-lg-12 col-12 mb_padding_0">
                  <div className="affiliate_partner_shd">
                    <h4 className="common_heading mb_commn_pd_0">
                      Other Affiliate Partner
                    </h4>
                    <div className="row product_new_btm_spc_web">
                      {allProductsData?.map((item) => {
                        // const image = item?.Images?.split('"');
                        // const imageURL = `${Apiurl()}/${image?.[3]}`;

                        const imagesArray = JSON.parse(item.Images);

                        const defaultImage = imagesArray.find(
                          (img) => img.Default
                        );

                        const imageUrl = defaultImage
                          ? `${Apiurl()}/${defaultImage.Images}`
                          : "";

                        const now = moment(); // Current time
                        const timeTo = moment(item?.ToPushlishDate);
                        const timeDifferenceInHours = timeTo.diff(now, "hours");
                        return (
                          <>
                            <div className="col-lg-3 col-sm-3 col-6 product_new_btm_spc">
                              <div
                                className={
                                  item?.IsProductOutOfStock === true
                                    ? "pro_detail_wrapper_new blur_effect"
                                    : "pro_detail_wrapper_new"
                                }
                              >
                                <div className="pro_dtl_main_spc_wrapper">
                                  <div className="pro_dtl_img_all_spc_wrapper">
                                    <img
                                      src={imageUrl}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "/Images/no-product-img-700.jpg";
                                      }}
                                      onClick={() => {
                                        router(
                                          `/productdetail/${Encryption(
                                            item?.Id
                                          )}`
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="pro_desc_spacing-new">
                                  <div className="pro_detail_modal_pointer">
                                    <h2>{item?.ProductName} </h2>
                                    <p>{item?.ProductDescription}</p>
                                    {item?.IsProductInOffer == false ? (
                                      <h3>
                                        Deal Price
                                        <span>₹ {item?.DealPrice}</span>
                                      </h3>
                                    ) : null}
                                    <h3>
                                      MRP<span>₹ {item?.Mrp}</span>
                                    </h3>
                                    {timeDifferenceInHours > 24 ? (
                                      <h3>
                                        <strong>
                                          Till:{" "}
                                          {moment(item?.ToPushlishDate).format(
                                            "LL"
                                          )}
                                        </strong>
                                      </h3>
                                    ) : (
                                      <ProductCountdown
                                        item={item}
                                        val="tillTime"
                                      />
                                    )}
                                  </div>
                                  <div className="mb-0">
                                    {item?.IsProductOutOfStock === true ? (
                                      <input
                                        type="button"
                                        value="Out of Stock"
                                        className="common_btn_new out_stock_btn_01"
                                      />
                                    ) : (
                                      <input
                                        type="button"
                                        onClick={() => {
                                          router(
                                            `/productdetail/${Encryption(
                                              item?.Id
                                            )}`
                                          );
                                        }}
                                        value={
                                          item?.IsProductInOffer == true
                                            ? "Bid Now"
                                            : item?.IsProductInOffer == false
                                            ? "Buy Now"
                                            : item?.IsProductInOffer == null
                                            ? "Contact Us"
                                            : null
                                        }
                                        className={
                                          item?.IsProductInOffer == true
                                            ? "common_btn_new bid_now_btn_01"
                                            : item?.IsProductInOffer == false
                                            ? "common_btn_new"
                                            : item?.IsProductInOffer == null
                                            ? "common_btn_new"
                                            : null
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                      {totalRecordAffiliate > 16 ? (
                        <div className="col-lg-12 mb_commn_pd_0">
                          <div className="pagination product_related_pagination">
                            {Array.from(
                              {
                                length: Math.ceil(
                                  totalRecordAffiliate / 16 || 16
                                ),
                              },
                              (_, i) => {
                                return (
                                  <>
                                    <a
                                      className={
                                        pageNumberAffiliate === i
                                          ? "active"
                                          : ""
                                      }
                                      onClick={() => getAllProducts(i, "pag")}
                                    >
                                      <span key={i}>{i + 1}</span>
                                    </a>
                                  </>
                                );
                              }
                            )}

                            {/* <a className="active"  >1</a>
                                                   <a className=""  >2</a> */}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default OtherAffiliatePartner;
